function mcInitReveal() {
  const els = document.querySelectorAll('.mc-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('mc-visible'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.mcDelay || 0;
          setTimeout(() => entry.target.classList.add('mc-visible'), Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach((el) => observer.observe(el));
}

function mcInitCountUp() {
  const els = document.querySelectorAll('.mc-count');
  if (!els.length) return;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = Number(el.dataset.mcTarget || 0);
        const duration = 1200;
        const start = performance.now();
        function tick(now) {
          const progress = Math.min((now - start) / duration, 1);
          el.textContent = Math.floor(progress * target).toString();
          if (progress < 1) requestAnimationFrame(tick);
          else el.textContent = target.toString();
        }
        requestAnimationFrame(tick);
        observer.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach((el) => observer.observe(el));
}

function mcFormatMoney(cents) {
  const value = Math.round(Number(cents) / 100);
  return '$' + value.toLocaleString('es-CL');
}

function mcInitGaleriaProducto() {
  document.querySelectorAll('.mc-producto[data-mc-section-id]').forEach((seccion) => {
    const id = seccion.dataset.mcSectionId;
    const principal = document.getElementById('mc-galeria-principal-' + id);
    const miniaturas = seccion.querySelectorAll('.mc-miniatura-btn');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach((btn) => {
      btn.addEventListener('click', () => {
        principal.src = btn.dataset.mcFull;
        miniaturas.forEach((otro) => { otro.style.borderColor = 'transparent'; });
        btn.style.borderColor = btn.dataset.mcAccent || 'transparent';
      });
    });
  });
}

function mcInitVariantesProducto() {
  document.querySelectorAll('.mc-producto[data-mc-section-id]').forEach((seccion) => {
    const id = seccion.dataset.mcSectionId;
    const script = document.getElementById('mc-variantes-' + id);
    const selects = seccion.querySelectorAll('.mc-select-opcion');
    if (!script || !selects.length) return;

    let variantes;
    try {
      variantes = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    const inputId = document.getElementById('mc-variant-id-' + id);
    const precioEl = document.getElementById('mc-precio-' + id);
    const precioComparadoEl = document.getElementById('mc-precio-comparado-' + id);
    const badgeOfertaEl = document.getElementById('mc-badge-oferta-' + id);
    const boton = document.getElementById('mc-btn-agregar-' + id);
    const botonTexto = document.getElementById('mc-btn-texto-' + id);

    function actualizar() {
      const seleccion = Array.from(selects)
        .sort((a, b) => Number(a.dataset.mcOptionIndex) - Number(b.dataset.mcOptionIndex))
        .map((s) => s.value);
      const match = variantes.find((v) => Array.isArray(v.options) && v.options.join('|||') === seleccion.join('|||'));
      if (!match) return;

      if (inputId) inputId.value = match.id;
      if (precioEl) precioEl.textContent = mcFormatMoney(match.price);
      const enOferta = match.compare_at_price && Number(match.compare_at_price) > Number(match.price);
      if (precioComparadoEl) {
        if (enOferta) {
          precioComparadoEl.textContent = mcFormatMoney(match.compare_at_price);
          precioComparadoEl.style.display = '';
        } else {
          precioComparadoEl.style.display = 'none';
        }
      }
      if (badgeOfertaEl) badgeOfertaEl.style.display = enOferta ? '' : 'none';
      if (boton) boton.disabled = !match.available;
      if (botonTexto && boton) botonTexto.textContent = match.available
        ? boton.dataset.mcTextoDisponible
        : boton.dataset.mcTextoAgotado;
    }

    selects.forEach((s) => s.addEventListener('change', actualizar));
  });
}

function mcRandTime() {
  if (Math.random() < 0.8) {
    const m = Math.max(1, Math.floor(Math.random() * 45));
    return 'hace ' + m + ' minuto' + (m === 1 ? '' : 's');
  }
  const h = Math.max(1, Math.floor(Math.random() * 5));
  return 'hace ' + h + ' hora' + (h === 1 ? '' : 's');
}

function mcInitNotificacionCompra() {
  const card = document.querySelector('.mc-notif__card');
  if (!card) return;
  const ciudades = window.mcNotifCiudades || [];
  const nombres = window.mcNotifNombres || [];
  const apellidos = window.mcNotifApellidos || [];
  if (!ciudades.length || !nombres.length) return;

  const head = card.querySelector('[data-mc-notif-head]');
  const time = card.querySelector('[data-mc-notif-time]');
  const closeBtn = card.querySelector('.mc-notif__close');
  const rand = (arr) => arr[Math.floor(Math.random() * arr.length)];

  let stopped = false;
  let hideTimer = null;

  function show() {
    if (stopped) return;
    head.textContent = rand(nombres) + ' ' + rand(apellidos) + ' · ' + rand(ciudades) + ' compró:';
    time.textContent = '✓ Compra verificada · ' + mcRandTime();
    card.hidden = false;
    card.style.display = 'flex';
    requestAnimationFrame(() => card.classList.add('mc-visible'));
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 5000);
  }

  function hide() {
    card.classList.remove('mc-visible');
    setTimeout(() => { card.style.display = 'none'; card.hidden = true; }, 350);
    if (!stopped) scheduleNext();
  }

  function scheduleNext() {
    const gap = 10000 + Math.random() * 10000;
    setTimeout(show, gap);
  }

  closeBtn.addEventListener('click', () => {
    stopped = true;
    hide();
  });

  setTimeout(show, 4000);
}

function mcInitContadorUrgencia() {
  document.querySelectorAll('.mc-urgencia').forEach((el) => {
    const numeroEl = el.querySelector('[data-mc-urgencia-numero]');
    const fraseEl = el.querySelector('[data-mc-urgencia-frase]');
    if (!numeroEl) return;
    const min = 4, max = 19;
    let current = Math.round(min + (max - min) * Math.random());

    function frase(n) {
      return n === 1 ? 'persona está viendo este producto ahora' : 'personas están viendo este producto ahora';
    }
    function render(n) {
      numeroEl.textContent = String(n);
      if (fraseEl) fraseEl.textContent = frase(n);
    }
    function next(n) {
      const r = Math.random();
      let nuevo = n;
      if (r < 0.3) nuevo = n;
      else if (r < 0.65) nuevo = n + 1;
      else nuevo = n - 1;
      return Math.max(min, Math.min(max, nuevo));
    }
    function tick() {
      current = next(current);
      render(current);
      setTimeout(tick, 4000 + Math.random() * 3000);
    }
    render(current);
    setTimeout(tick, 4000 + Math.random() * 3000);
  });
}

function mcInitMarqueeAnnouncement() {
  document.querySelectorAll('.announcement-bar__message').forEach((msg) => {
    if (msg.dataset.mcMarqueeDone) return;
    const span = msg.querySelector('span');
    if (!span) return;
    msg.dataset.mcMarqueeDone = 'true';
    const text = span.textContent.trim();
    const track = document.createElement('div');
    track.className = 'mc-marquee-track';
    track.innerHTML = '<span>' + text + '</span><span aria-hidden="true">' + text + '</span>';
    msg.innerHTML = '';
    msg.appendChild(track);
  });
}

function mcInitPackAhorro() {
  document.querySelectorAll('.mc-pack').forEach((pack) => {
    const radios = pack.querySelectorAll('.mc-pack__radio');
    const qtyInput = pack.querySelector('input[name="quantity"]');
    if (!radios.length || !qtyInput) return;
    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        qtyInput.value = radio.dataset.mcQty || '1';
        radios.forEach((r) => {
          const tile = r.closest('.mc-pack__tile');
          if (!tile) return;
          tile.style.borderColor = r.checked ? tile.dataset.mcAccent || '#5B8FA8' : 'var(--mc-color-fondo-alt)';
        });
      });
      const tile = radio.closest('.mc-pack__tile');
      if (tile) tile.dataset.mcAccent = getComputedStyle(tile).borderColor;
    });
  });
}

// Cuenta regresiva hasta la hora de corte de despacho. Usa la hora real de
// Chile (America/Santiago) sin importar dónde esté el visitante, y cuando
// el corte ya pasó cambia el mensaje a "mañana" en vez de seguir apurando.
function mcHoraChile() {
  const partes = new Intl.DateTimeFormat('es-CL', {
    timeZone: 'America/Santiago',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
  }).formatToParts(new Date());
  const val = (t) => parseInt(partes.find((p) => p.type === t).value, 10);
  return { h: val('hour') % 24, m: val('minute'), s: val('second') };
}

function mcInitCorteDespacho() {
  document.querySelectorAll('[data-mc-corte]').forEach((el) => {
    const textoEl = el.querySelector('[data-mc-corte-texto]');
    const corte = parseInt(el.dataset.horaCorte, 10);
    if (!textoEl || isNaN(corte)) return;

    function render() {
      const ahora = mcHoraChile();
      const seg = ahora.h * 3600 + ahora.m * 60 + ahora.s;
      const restante = corte * 3600 - seg;

      if (restante <= 0) {
        textoEl.innerHTML = 'Pide ahora y tu pedido entra a despacho <strong>mañana a primera hora</strong>.';
      } else {
        const h = Math.floor(restante / 3600);
        const m = Math.floor((restante % 3600) / 60);
        const falta = h > 0 ? h + ' h ' + m + ' min' : m + ' min';
        textoEl.innerHTML = 'Pide en las próximas <strong>' + falta + '</strong> y tu pedido entra a despacho <strong>hoy mismo</strong>.';
      }
      el.hidden = false;
    }

    render();
    setInterval(render, 60000);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  mcInitReveal();
  mcInitCountUp();
  mcInitGaleriaProducto();
  mcInitVariantesProducto();
  mcInitNotificacionCompra();
  mcInitContadorUrgencia();
  mcInitCorteDespacho();
  mcInitPackAhorro();
  mcInitMarqueeAnnouncement();
});
